export const navItems = [
    { text: 'Home', to:"/"},
    { text: 'About', to:"/about"},
    { text: 'Content', to:"/content"}
];